import { ReceiptText, ChevronRight } from "lucide-react";
import CategoryPageShell from "../../../components/workspace/CategoryPageShell";

export default function TaxAdmin() {
  return (
    <CategoryPageShell
      testId="pcc-category-tax-admin"
      slug="tax-admin"
      eyebrow="Tax & Admin"
      title="Stay organised. Feel prepared for tax season."
      description="Practical admin tools for independent carers — track income, expenses, mileage and invoices, and compile a clearer pack for your accountant or Self Assessment records. Not tax advice."
    >
      <section id="tax-confidence-kit" className="scroll-mt-24 min-w-0" data-testid="pro-tool-tax-confidence-kit-section">
        <a
          href="/workspace/tools/tax-confidence-kit"
          className="group rounded-2xl border border-slate-200 bg-white p-6 hover:border-purple hover:shadow-md transition-all block"
          data-testid="pro-tool-tax-confidence-kit-card"
        >
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 rounded-xl bg-purple/10 text-purple flex items-center justify-center shrink-0">
              <ReceiptText className="w-5 h-5" strokeWidth={1.75} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-display font-semibold text-lg">Tax Confidence Kit</h3>
              <p className="mt-2 text-ink-muted text-sm leading-relaxed">
                Track income, expenses, mileage and invoices — including the Invoice Generator and Invoice Record —
                so you can prepare a clearer pack for your accountant or Self Assessment records.
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-purple text-sm font-medium">
                Open Tax Confidence Kit
                <ChevronRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" strokeWidth={2} />
              </span>
            </div>
          </div>
        </a>
      </section>
    </CategoryPageShell>
  );
}
